import React, { Component, Fragment } from "react";
import { matchPath } from "react-router";
import api from "services/api";

import { connect } from "react-redux";

import { Page, Form, Loading } from "components";

import { withTranslation } from "react-i18next";
import { compose } from "recompose";

const letter = ["A", "B"];

class South extends Component {
  state = {
    confirmed: false,
    journey: {},
    quiz: {},
    loading: true,
    answering: false,
    initializated: false
  };

  async componentDidMount() {
    await localStorage.setItem("south_face_initializated", true);
    this.loadInterview();
  }

  loadInterview = async () => {
    const { history } = this.props;

    const response = await api.get(`search/interviews/${this.handleGetID()}`);
    const { data } = response.data;

    const type = data.attributes.interviewable_type;
    const IS_SOUTH = "SouthFace::Quiz";

    const face =
      type === IS_SOUTH
        ? data.attributes.interviewable
        : data.attributes.interviewable.south_face_quiz;

    if (face.current_question === 0) {
      history.push(
        `/journey/${this.handleGetID()}/${
          type === IS_SOUTH ? "complete" : "east"
        }`
      );
      return;
    } else if (face.current_question === 1) {
      await localStorage.setItem("south_face_initializated", false);
    }

    const initializated = await JSON.parse(
      localStorage.getItem("south_face_initializated")
    );
    this.setState({ initializated });

    this.setState({ journey: face });
    this.loadQuiz(face);
  };

  loadQuiz = async face => {
    const response = await api.get(
      `south_face/quizzes/${face.id}/questions/page?page=${face.current_question}&per=1`
    );
    const { data } = response.data;

    const quiz = data[0];

    this.setState({
      quiz: {
        ...quiz,
        attributes: {
          ...quiz.attributes,
          question: {
            ...quiz.attributes.question,
            alternatives: quiz.attributes.question.alternatives.map(
              (alternative, index) => ({
                ...alternative,
                value: index === 0 ? 4 : 3
              })
            )
          }
        }
      },
      loading: false,
      answering: false
    });
  };

  handleGetID = () => {
    const { location } = this.props;
    const match = matchPath(location.pathname, { path: "/journey/:id/south" });
    return match.params.id;
  };

  handleChangeAlternative = (id, value) => {
    const { journey, quiz } = this.state;

    quiz.attributes.question.alternatives = quiz.attributes.question.alternatives.map(
      alternative => ({
        ...alternative,
        value: alternative.id === id ? value : journey.points - value
      })
    );

    this.setState({ quiz });
  };

  handleConfirm = () => {
    const { confirmed } = this.state;

    this.setState({ confirmed: !confirmed });
  };

  handleAnswer = async () => {
    const { quiz } = this.state;
    const { user } = this.props;

    this.setState({ answering: true });

    await api.post(`south_face/quizzes/quizquestion/${quiz.id}/respond`, {
      interview_id: this.handleGetID(),
      person_id: user.data.id,
      alternatives: quiz.attributes.question.alternatives
    });

    this.setState({ confirmed: false });

    await this.loadInterview();
  };

  handleInitialize = async () => {
    await localStorage.setItem("south_face_initializated", true);
    this.setState({ initializated: true });
  };

  render() {
    const {
      confirmed,
      journey,
      quiz,
      loading,
      answering,
      initializated
    } = this.state;
    const { t } = this.props;

    return (
      <Page className="journey">
        {!loading && (
          <Fragment>
            {!initializated ? (
              <div className="text-center">
                <div className="header">
                  <div className="title">
                    <span className="face">{journey.instructions_content}</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      className="button-submit"
                      onClick={this.handleInitialize}
                    >
                      {t("Iniciar Questionário")}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Fragment>
                <div className="header">
                  <span className="step">{`${journey.current_question}/${journey.total_questions}`}</span>
                  <div className="title">
                    <span className="face">{t("Face Sul")}</span>
                    <span className="question">
                      {quiz.attributes.question.title}
                    </span>
                  </div>
                </div>

                <div className="questions">
                  <div className="options options-slide">
                    <span>{t("Menos")}</span>
                    <span>{t("Me Identifico")}</span>
                    <span>{t("Mais")}</span>
                  </div>

                  {quiz.attributes.question.alternatives.map(
                    (alternative, index) => (
                      <div className="question" key={alternative.id}>
                        <div className="question-title">
                          <span className="question-label">
                            {letter[index]}
                          </span>
                          <span className="question-name">
                            {alternative.title}
                          </span>
                        </div>

                        <div className="question-options">
                          <Form.Slider
                            minValue={1}
                            maxValue={journey.points - 1}
                            value={alternative.value}
                            onChange={value =>
                              this.handleChangeAlternative(
                                alternative.id,
                                value
                              )
                            }
                          />
                          <div className="option-value">
                            {alternative.value}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>

                <div className="buttons">
                  <button
                    type="button"
                    disabled={!confirmed || answering}
                    className="button-submit"
                    onClick={this.handleAnswer}
                  >
                    {answering ? (
                      <Loading size="xs" text={t("Respondendo...")} />
                    ) : (
                      t("Próxima Questão")
                    )}
                  </button>

                  <Form.Checkbox
                    label={t("Confirmar Resposta")}
                    checked={confirmed}
                    onChange={this.handleConfirm}
                  />
                </div>
              </Fragment>
            )}
          </Fragment>
        )}
      </Page>
    );
  }
}

const mapState = state => ({
  user: state.auth.user
});

export default compose(connect(mapState), withTranslation())(South);



// WEBPACK FOOTER //
// ./src/pages/Journey/South/index.js